// import moment from "moment";

// export const handlePrint = (
//   filteredData,
//   saleReturnData,
//   purchaseData,
//   purchaseReturnData,
//   supplierData,
//   receiptData,
//   bankData,
//   journalReceiptData,
//   journalPaymentData,
// ) => {
//   const printWindow = window.open("", "", "height=700,width=900");
//   const currentDate = new Date().toLocaleDateString();

//   printWindow.document.write(
//     "<html><head><title>Day Glance Report</title><style>",
//   );

//   // Styles
//   printWindow.document.write(`
//       body {
//         font-family: Arial, sans-serif;
//         margin: 20px;
//       }
//       .header {
//         text-align: center;
//         margin-bottom: 20px;
//       }
//       .header h1 {
//         margin: 0;
//         font-size: 18px;
//       }
//       .header .date {
//         font-size: 12px;
//         margin-top: 5px;
//       }
//       table {
//         width: 100%;
//         border-collapse: collapse;
//         overflow-x: auto;
//       }
//       th, td {
//         padding: 3px 3px;
//         text-align: right;
//         border: 1px solid #3b3b3b;
//         width: 100px;
//         font-size: 10px;
//       }
//       th {
//         background-color: #f4f4f4;
//         font-weight: bold;
//       }
//       td {
//         background-color: #f4f4f4;
//         font-weight: bold;
//         height: 10px;
//       }
//       th:first-child, td:first-child {
//         text-align: left;
//       }
//       td.description {
//         text-align: center;
//       }
//       .group-header {
//         text-align: center;
//         font-size: 14px;
//         font-weight: bold;
//         margin-top: 20px;
//         margin-bottom: 10px;
//       }
//       .table-container {
//         margin-top: 10px;
//       }
//       .totals-row {
//         background-color: #dfefff;
//         font-weight: bold;
//       }
//     `);

//   printWindow.document.write("</style></head><body>");

//   // Header
//   printWindow.document.write(`
//       <div class="header">
//         <h1>Day Glance Report</h1>
//         <p class="date">Date: ${currentDate}</p>
//       </div>
//     `);

//   printWindow.document.write(`
//         <div class="group-header">SALE</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const groupTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   filteredData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [groupTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${groupTotals.QTY}</td>
//           <td>${groupTotals.TOTAMT.toFixed(2)}</td>
//           <td>${groupTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${groupTotals.NETAMT.toFixed(2)}</td>
//           <td>${groupTotals.CASH.toFixed(2)}</td>
//           <td>${groupTotals.CARD.toFixed(2)}</td>
//           <td>${groupTotals.UPI.toFixed(2)}</td>
//           <td>${groupTotals.ONLINE.toFixed(2)}</td>
//           <td>${groupTotals.BALANCE.toFixed(2)}</td>
//           <td>${groupTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">SALE RETURN</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const returnTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   saleReturnData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [returnTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${returnTotals.QTY}</td>
//           <td>${returnTotals.TOTAMT.toFixed(2)}</td>
//           <td>${returnTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${returnTotals.NETAMT.toFixed(2)}</td>
//           <td>${returnTotals.CASH.toFixed(2)}</td>
//           <td>${returnTotals.CARD.toFixed(2)}</td>
//           <td>${returnTotals.UPI.toFixed(2)}</td>
//           <td>${returnTotals.ONLINE.toFixed(2)}</td>
//           <td>${returnTotals.BALANCE.toFixed(2)}</td>
//           <td>${returnTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">PURCHASE</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const purchaseTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   purchaseData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [purchaseTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${purchaseTotals.QTY}</td>
//           <td>${purchaseTotals.TOTAMT.toFixed(2)}</td>
//           <td>${purchaseTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${purchaseTotals.NETAMT.toFixed(2)}</td>
//           <td>${purchaseTotals.CASH.toFixed(2)}</td>
//           <td>${purchaseTotals.CARD.toFixed(2)}</td>
//           <td>${purchaseTotals.UPI.toFixed(2)}</td>
//           <td>${purchaseTotals.ONLINE.toFixed(2)}</td>
//           <td>${purchaseTotals.BALANCE.toFixed(2)}</td>
//           <td>${purchaseTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">PURCHASE RETURN</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const purchaseReturnTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   purchaseReturnData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [purchaseReturnTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${purchaseReturnTotals.QTY}</td>
//           <td>${purchaseReturnTotals.TOTAMT.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.NETAMT.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.CASH.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.CARD.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.UPI.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.ONLINE.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.BALANCE.toFixed(2)}</td>
//           <td>${purchaseReturnTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">SUPPLIER PAYMENT</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const supplierTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   supplierData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [supplierTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${supplierTotals.QTY}</td>
//           <td>${supplierTotals.TOTAMT.toFixed(2)}</td>
//           <td>${supplierTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${supplierTotals.NETAMT.toFixed(2)}</td>
//           <td>${supplierTotals.CASH.toFixed(2)}</td>
//           <td>${supplierTotals.CARD.toFixed(2)}</td>
//           <td>${supplierTotals.UPI.toFixed(2)}</td>
//           <td>${supplierTotals.ONLINE.toFixed(2)}</td>
//           <td>${supplierTotals.BALANCE.toFixed(2)}</td>
//           <td>${supplierTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">RECEIPT</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const receiptTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   receiptData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [receiptTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${receiptTotals.QTY}</td>
//           <td>${receiptTotals.TOTAMT.toFixed(2)}</td>
//           <td>${receiptTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${receiptTotals.NETAMT.toFixed(2)}</td>
//           <td>${receiptTotals.CASH.toFixed(2)}</td>
//           <td>${receiptTotals.CARD.toFixed(2)}</td>
//           <td>${receiptTotals.UPI.toFixed(2)}</td>
//           <td>${receiptTotals.ONLINE.toFixed(2)}</td>
//           <td>${receiptTotals.BALANCE.toFixed(2)}</td>
//           <td>${receiptTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">BANK ENTRYS</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const bankTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   bankData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [bankTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${bankTotals.QTY}</td>
//           <td>${bankTotals.TOTAMT.toFixed(2)}</td>
//           <td>${bankTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${bankTotals.NETAMT.toFixed(2)}</td>
//           <td>${bankTotals.CASH.toFixed(2)}</td>
//           <td>${bankTotals.CARD.toFixed(2)}</td>
//           <td>${bankTotals.UPI.toFixed(2)}</td>
//           <td>${bankTotals.ONLINE.toFixed(2)}</td>
//           <td>${bankTotals.BALANCE.toFixed(2)}</td>
//           <td>${bankTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">JOURNAL RECEIPT</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const journalReceiptTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   journalReceiptData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [journalReceiptTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${journalReceiptTotals.QTY}</td>
//           <td>${journalReceiptTotals.TOTAMT.toFixed(2)}</td>
//           <td>${journalReceiptTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${journalReceiptTotals.NETAMT.toFixed(2)}</td>
//           <td>${journalReceiptTotals.CASH.toFixed(2)}</td>
//           <td>${journalReceiptTotals.CARD.toFixed(2)}</td>
//           <td>${journalReceiptTotals.UPI.toFixed(2)}</td>
//           <td>${journalReceiptTotals.ONLINE.toFixed(2)}</td>
//           <td>${journalReceiptTotals.BALANCE.toFixed(2)}</td>
//           <td>${journalReceiptTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write(`
//         <div class="group-header">JOURNAL PAYMENT</div>
//         <div class="table-container">
//           <table>
//             <thead>
//               <tr>
//                 <th>INVNO</th>
//               <th>QTY</th>
//               <th>TOT AMT</th>
//               <th>DISCOUNT</th>
//               <th>NET AMT</th>
//               <th>CASH</th>
//               <th>CARD</th>
//               <th>UPI</th>
//               <th>ONLINE</th>
//               <th>BALANCE</th>
//               <th>CHEQUE</th>
//               </tr>
//             </thead>
//             <tbody>
//       `);

//   const journalPaymentTotals = {
//     QTY: 0,
//     TOTAMT: 0,
//     DISCOUNT: 0,
//     NETAMT: 0,
//     CASH: 0,
//     CARD: 0,
//     UPI: 0,
//     ONLINE: 0,
//     BALANCE: 0,
//     CHEQUE: 0,
//   };

//   journalPaymentData.map((item) => {
//     // Print row
//     printWindow.document.write(`
//           <tr>
//             <td>${item.billno}</td>
//                   <td>${item.totqty}</td>
//                   <td>${item.totamt}</td>
//                   <td>${item.discount}</td>
//                   <td>${item.NETAMT}</td>
//                   <td>${item.PAIDCASH}</td>
//                   <td >${item.PAIDCARD}</td>
//                   <td >${item.PAIDUPI}</td>
//                   <td >${item.PAIDONLINE}</td>
//                   <td >${item.BALANCE}</td>
//                   <td >${item.PAIDCHEQUE}</td>
//                 </tr>
//                 <tr>
//                   <td colSpan="1">
//                     ${moment(item.BillDate).format("DD/MM/YYYY")}
//                   </td>
//                   <td colSpan="4" className="description">
//                     ${item.CustName}
//                   </td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//                   <td colSpan="1"></td>
//           </tr>
//         `);

//     // Update group + grand totals
//     const target = [journalPaymentTotals];
//     target.forEach((totals) => {
//       totals.QTY += Number(item.totqty || 0);
//       totals.TOTAMT += parseFloat(item.TOTAMT || 0);
//       totals.DISCOUNT += parseFloat(item.discount || 0);
//       totals.NETAMT += parseFloat(item.NETAMT || 0);
//       totals.CASH += parseFloat(item.PAIDCASH || 0);
//       totals.CARD += parseFloat(item.PAIDCARD || 0);
//       totals.UPI += parseFloat(item.PAIDUPI || 0);
//       totals.ONLINE += parseFloat(item.PAIDONLINE || 0);
//       totals.BALANCE += parseFloat(item.BALANCE || 0);
//       totals.CHEQUE += parseFloat(item.PAIDCHEQUE || 0);
//     });
//   });

//   // Print group totals row
//   printWindow.document.write(`
//         <tr class="totals-row">
//           <td>Total</td>
//           <td>${journalPaymentTotals.QTY}</td>
//           <td>${journalPaymentTotals.TOTAMT.toFixed(2)}</td>
//           <td>${journalPaymentTotals.DISCOUNT.toFixed(2)}</td>
//           <td>${journalPaymentTotals.NETAMT.toFixed(2)}</td>
//           <td>${journalPaymentTotals.CASH.toFixed(2)}</td>
//           <td>${journalPaymentTotals.CARD.toFixed(2)}</td>
//           <td>${journalPaymentTotals.UPI.toFixed(2)}</td>
//           <td>${journalPaymentTotals.ONLINE.toFixed(2)}</td>
//           <td>${journalPaymentTotals.BALANCE.toFixed(2)}</td>
//           <td>${journalPaymentTotals.CHEQUE.toFixed(2)}</td>
//         </tr>
//       `);

//   printWindow.document.write("</tbody></table></div><br>");

//   printWindow.document.write("</body></html>");
//   printWindow.document.close();
//   printWindow.print();
// };

import moment from "moment";

export const handlePrint = (
  filteredData = [],
  saleReturnData = [],
  purchaseData = [],
  purchaseReturnData = [],
  supplierData = [],
  receiptData = [],
  bankData = [],
  journalReceiptData = [],
  journalPaymentData = [],
) => {
  const currentDate = new Date().toLocaleDateString();

  /* ---------------- HTML START ---------------- */
  let htmlContent = `
  <html>
    <head>
      <title>Day Glance Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 20px;
        }
        .header {
          text-align: center;
          margin-bottom: 20px;
        }
        .header h1 {
          margin: 0;
          font-size: 18px;
        }
        .header .date {
          font-size: 12px;
          margin-top: 5px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
        }
        th, td {
          border: 1px solid #3b3b3b;
          padding: 3px;
          font-size: 10px;
          text-align: right;
        }
        th {
          background: #d4d2d2ff;
          font-weight: bold;
        }
        th:first-child,
        td:first-child {
          text-align: left;
        }
        .group-header {
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin: 15px 0 8px;
        }
        .totals-row {
          background: #dfefff;
          font-weight: bold;
        }
        .desc {
          text-align: center;
          font-weight: normal;
        }
        @media print {
          .group-header {
            page-break-before: auto;
          }
        }
          * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>Day Glance Report</h1>
        <div class="date">Date: ${currentDate}</div>
      </div>
  `;
  /* ---------------- HTML END ---------------- */

  /* ----------- TABLE RENDER FUNCTION ----------- */
  const renderTable = (title, data) => {
    if (!Array.isArray(data) || data.length === 0) return "";
    let totals = {
      QTY: 0,
      TOTAMT: 0,
      DISCOUNT: 0,
      NETAMT: 0,
      CASH: 0,
      CARD: 0,
      UPI: 0,
      ONLINE: 0,
      BALANCE: 0,
      CHEQUE: 0,
    };

    let rows = "";

    data.forEach((item) => {
      rows += `
        <tr>
          <td>${item.billno || ""}</td>
          <td>${item.totqty || 0}</td>
          <td>${item.totamt || 0}</td>
          <td>${item.discount || 0}</td>
          <td>${item.NETAMT || 0}</td>
          <td>${item.PAIDCASH || 0}</td>
          <td>${item.PAIDCARD || 0}</td>
          <td>${item.PAIDUPI || 0}</td>
          <td>${item.PAIDONLINE || 0}</td>
          <td>${item.BALANCE || 0}</td>
          <td>${item.PAIDCHEQUE || 0}</td>
        </tr>
        <tr>
          <td>${moment(item.BillDate).format("DD/MM/YYYY")}</td>
          <td colspan="4" class="desc">${item.CustName || ""}</td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
        </tr>
      `;

      totals.QTY += Number(item.totqty || 0);
      totals.TOTAMT += Number(item.totamt || 0);
      totals.DISCOUNT += Number(item.discount || 0);
      totals.NETAMT += Number(item.NETAMT || 0);
      totals.CASH += Number(item.PAIDCASH || 0);
      totals.CARD += Number(item.PAIDCARD || 0);
      totals.UPI += Number(item.PAIDUPI || 0);
      totals.ONLINE += Number(item.PAIDONLINE || 0);
      totals.BALANCE += Number(item.BALANCE || 0);
      totals.CHEQUE += Number(item.PAIDCHEQUE || 0);
    });

    return `
      <div class="group-header">${title}</div>
      <table>
        <thead>
          <tr>
            <th>INVNO</th>
            <th>QTY</th>
            <th>TOT AMT</th>
            <th>DISCOUNT</th>
            <th>NET AMT</th>
            <th>CASH</th>
            <th>CARD</th>
            <th>UPI</th>
            <th>ONLINE</th>
            <th>BALANCE</th>
            <th>CHEQUE</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
          <tr class="totals-row">
            <td>Total</td>
            <td>${totals.QTY}</td>
            <td>${totals.TOTAMT.toFixed(2)}</td>
            <td>${totals.DISCOUNT.toFixed(2)}</td>
            <td>${totals.NETAMT.toFixed(2)}</td>
            <td>${totals.CASH.toFixed(2)}</td>
            <td>${totals.CARD.toFixed(2)}</td>
            <td>${totals.UPI.toFixed(2)}</td>
            <td>${totals.ONLINE.toFixed(2)}</td>
            <td>${totals.BALANCE.toFixed(2)}</td>
            <td>${totals.CHEQUE.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    `;
  };

  /* ----------- APPEND ALL SECTIONS ----------- */
  htmlContent += renderTable("SALE", filteredData);
  htmlContent += renderTable("SALE RETURN", saleReturnData);
  htmlContent += renderTable("PURCHASE", purchaseData);
  htmlContent += renderTable("PURCHASE RETURN", purchaseReturnData);
  htmlContent += renderTable("SUPPLIER PAYMENT", supplierData);
  htmlContent += renderTable("RECEIPT", receiptData);
  htmlContent += renderTable("BANK ENTRYS", bankData);
  htmlContent += renderTable("JOURNAL RECEIPT", journalReceiptData);
  htmlContent += renderTable("JOURNAL PAYMENT", journalPaymentData);

  htmlContent += `
    </body>
  </html>
  `;

  /* ----------- IFRAME PRINT ----------- */
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  document.body.appendChild(iframe);

  iframe.contentWindow.document.open();
  iframe.contentWindow.document.write(htmlContent);
  iframe.contentWindow.document.close();

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => iframe.remove(), 1500);
  };
};
